interface TokenGeneratorOptions {
  /** Auth0 API to mint the token for; defaults to the Superblocks API. */
  audience?: string;
  ignoreCache?: boolean;
  /** Space-separated scopes to request alongside the audience. */
  scope?: string;
}

class AuthProvider {
  private static instance: AuthProvider;
  private tokenGenerator?: (options?: TokenGeneratorOptions) => Promise<string>;

  private constructor() {}

  setTokenGenerator(
    tokenGenerator: (options?: TokenGeneratorOptions) => Promise<string>,
  ) {
    this.tokenGenerator = tokenGenerator;
  }

  removeTokenGenerator() {
    this.tokenGenerator = undefined;
  }

  async generateToken(options?: TokenGeneratorOptions) {
    if (!this.tokenGenerator) {
      throw new Error("tokenGenerator accessed without initialization");
    }
    return await this.tokenGenerator(options);
  }

  async generateFreshToken() {
    return await this.generateToken({ ignoreCache: true });
  }

  ready(): boolean {
    return !!this.tokenGenerator;
  }

  public static get Instance() {
    return this.instance || (this.instance = new this());
  }
}

export default AuthProvider.Instance;
